export default "__VITE_ASSET__DkKPcrNb__"